export const API_URL =
  process.env.REACT_APP_API_URL || "https://whatnextbackendadmin.vercel.app/api";
const TOKEN_KEY = "wne_admin_token";
const ADMIN_KEY = "wne_admin_user";
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setSession(token, admin) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(ADMIN_KEY, JSON.stringify(admin));
}
export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ADMIN_KEY);
}
export function getStoredAdmin() {
  try {
    const raw = localStorage.getItem(ADMIN_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
async function request(path, { method = "GET", body, isForm = false, auth = true } = {}) {
  const headers = {};
  if (!isForm) headers["Content-Type"] = "application/json";
  if (auth) {
    const token = getToken();
    if (token) headers["Authorization"] = `Bearer ${token}`;
  }
  let res;
  try {
    res = await fetch(`${API_URL}${path}`, {
      method,
      headers,
      body: body ? (isForm ? body : JSON.stringify(body)) : undefined,
    });
  } catch (networkErr) {
    throw new Error(
      "Could not reach the backend API. Check that it's running and REACT_APP_API_URL is set correctly."
    );
  }
  let data = null;
  const text = await res.text();
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
  }
  if (!res.ok) {
    const message = (data && data.message) || `Request failed (${res.status})`;
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }
  return data;
}
export const authApi = {
  login: (email, password) =>
    request("/auth/login", { method: "POST", body: { email, password }, auth: false }),
  me: () => request("/auth/me"),
  changePassword: (currentPassword, newPassword) =>
    request("/auth/change-password", { method: "PUT", body: { currentPassword, newPassword } }),
};
export const courseApi = {
  listAll: () => request("/courses/admin/all"),
  get: (idOrSlug) => request(`/courses/${idOrSlug}`),
  create: (data) => request("/courses", { method: "POST", body: data }),
  update: (id, data) => request(`/courses/${id}`, { method: "PUT", body: data }),
  remove: (id) => request(`/courses/${id}`, { method: "DELETE" }),
  duplicate: (id) => request(`/courses/${id}/duplicate`, { method: "POST" }),
  reorder: (order) => request(`/courses/reorder`, { method: "PUT", body: { order } }),
};
export const blogApi = {
  listAll: () => request("/blogs/admin/all"),
  get: (idOrSlug) => request(`/blogs/${idOrSlug}`),
  create: (data) => request("/blogs", { method: "POST", body: data }),
  update: (id, data) => request(`/blogs/${id}`, { method: "PUT", body: data }),
  remove: (id) => request(`/blogs/${id}`, { method: "DELETE" }),
};
export const faqApi = {
  listAll: () => request("/faqs/admin/all"),
  create: (data) => request("/faqs", { method: "POST", body: data }),
  update: (id, data) => request(`/faqs/${id}`, { method: "PUT", body: data }),
  remove: (id) => request(`/faqs/${id}`, { method: "DELETE" }),
  reorder: (order) => request("/faqs/reorder", { method: "PUT", body: { order } }),
};
export const publicApi = {
  listCourses: () => request("/courses", { auth: false }),
  getCourse: (slug) => request(`/courses/${slug}`, { auth: false }),
  listBlogs: () => request("/blogs", { auth: false }),
  getBlog: (slug) => request(`/blogs/${slug}`, { auth: false }),
  listFaqs: () => request("/faqs", { auth: false }),
};
export async function uploadImage(file) {
  const form = new FormData();
  form.append("image", file);
  const data = await request("/uploads", { method: "POST", body: form, isForm: true });
  return data.url;
}